export namespace DateFormatConstants {
    export const YearMonthDayFormat: string = 'YYYY-MM-DD';
}